/**
 * La mélodie est-elle réellement sortie ?
 *
 * On observe la piste **pendant** sa lecture, à petits coups, et non une fois
 * la mélodie finie. L'interroger après `CHIME_MS` tombe au moment exact où
 * elle vient de se terminer : `playing` est retombé à faux et la position à
 * zéro, si bien qu'une lecture parfaitement réussie est indiscernable d'une
 * lecture refusée — et l'écran annonce « ton navigateur a bloqué le son » à un
 * élève qui l'entend. Le pire cas pour un écran de diagnostic : celui où il
 * contredit ce que l'élève constate.
 *
 * Le lecteur expo-audio lance `media.play()` sans attendre sa promesse : le
 * refus du navigateur (`NotAllowedError`) ne remonte à personne, et son
 * `player.playing` passe à vrai même quand la lecture est refusée. Seul
 * `currentStatus`, lu sur l'élément média lui-même, dit ce qui s'est passé.
 *
 * Une piste encore en chargement n'est pas une réponse : on attend. Sur web,
 * le lecteur se dit chargé d'office ; seule sa durée, inconnue tant que le
 * fichier n'est pas arrivé, dit qu'il l'est vraiment — sans quoi une connexion
 * lente passerait pour un son bloqué. Le doute profite toujours à la lecture —
 * pas de lecteur, plateforme qui ne renseigne rien, piste jamais chargée,
 * erreur de lecture du statut — on n'affirme rien.
 *
 * @returns {Promise<boolean>} vrai dès qu'on a vu la piste avancer
 */
export async function playbackStarted(player, windowMs) {
    const deadline = Date.now() + windowMs
    let sawLoaded = false
    while (Date.now() < deadline) {
        let status
        try {
            status = player?.currentStatus
        } catch (error) {
            return true
        }
        if (!status) return true
        if (status.isLoaded && status.duration > 0) {
            sawLoaded = true
            if (status.playing || status.currentTime > 0 || status.didJustFinish) {
                return true
            }
        }
        // eslint-disable-next-line no-await-in-loop
        await new Promise((resolve) => setTimeout(resolve, 90))
    }
    return !sawLoaded
}
